export const BASE_URL = "https://hxb.wwwlab.top/api-service";
